import { resolveDemoCallLink } from './resolve-demo-call-link.js';

export function normalizeDemoCallLinks() {
    const links = document.querySelectorAll('a[href="#demo-call"], a[href="/#demo-call"]');

    if (!links.length) {
        return;
    }

    links.forEach((link) => {
        const currentHref = link.getAttribute('href') || '#demo-call';
        const resolvedHref = resolveDemoCallLink(currentHref);

        if (resolvedHref !== currentHref) {
            link.setAttribute('href', resolvedHref);
        }
    });
}
